module.exports = __webpack_public_path__ + "static/japanese-da310abd1d72535613f0318d77571ffd.png";